 const logger = store => next => action => {
    // console.log("Middleware store:", store);
    // console.log("Middleware next:", next);
    // console.log("Middleware action:", action);
    next(action);
}

export default logger;